<template>
  <div
    id="base-layout"
    v-resize="onResize"
    class="base-layout"
    :class="[
      $style.base,
      {
        'navigation-drawer--open': drawerIsVisible,
        'base-layout--hide-navigation': appBarIsHidden,
        'base-layout--reduced-height': reducedHeight,
      },
    ]"
  >
    <div class="loader">Loading…</div>
    <v-app>
      <slot />

      <Notifications />
      <MessagePreview />
      <div class="base-layout__apptop" :class="$style.apptop"></div>
    </v-app>
    <v-overlay class="base-layout__overlay" :value="overlayIsVisible">
      <div :class="$style.overlay" @click="setOverlayInactive"></div>
    </v-overlay>
    <v-overlay :class="$style.appoverlay" :value="appPending" opacity="0.75">
      <div :class="$style.apploader">
        <PonSpinner />
      </div>
    </v-overlay>

    <portal-target v-for="target in portalTargets" :key="target" :name="target" />
    <LoginDialog :open="loginStarted" />
    <ServiceWorkerNotSupported v-if="serviceWorkerNotSupported" :open="serviceWorkerNotSupported" />
  </div>
</template>

<script>
import { debounce } from 'lodash-es'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'
import APP_MUTATIONS from '@/js/plugins/store/modules/app/mutation-types.js'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'

import MessagePreview from '@/js/components/MessageCenter/modals/MessagePreview.vue'

import { PonSpinner } from '@/js/components/Shared/index.js'
import Notifications from '@/js/components/Notifications/Notifications.vue'
import LoginDialog from '@/js/components/Login/LoginDialog.vue'
import ServiceWorkerNotSupported from '@/js/components/Login/ServiceWorkerNotSupported.vue'

export default {
  name: 'BaseLayout',
  components: {
    PonSpinner,
    Notifications,
    LoginDialog,
    ServiceWorkerNotSupported,
    MessagePreview,
  },
  data() {
    return {
      loginStarted: false,
      serviceWorkerNotSupported: false,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      overlayIsVisible: APP_GETTERS.OVERLAY_VISIBILITY,
      drawerIsVisible: APP_GETTERS.NAVIGATION_DRAWER_VISIBILITY,
      portalTargets: APP_GETTERS.PORTAL_TARGETS,
      // notificationMessage: APP_GETTERS.NOTIFICATION_MESSAGE,
      // notificationMessageOpen: APP_GETTERS.NOTIFICATION_MESSAGE_OPEN,
      // notificationMessageType: APP_GETTERS.NOTIFICATION_MESSAGE_TYPE,
    }),
    ...mapState(STOREMODULES.APP, {
      appPending: APP_CONSTANTS.APP_PENDING,
      appBarIsHidden: APP_CONSTANTS.APP_BAR_IS_HIDDEN,
      notifications: APP_CONSTANTS.NOTIFICATIONS,
    }),
    reducedHeight() {
      return this.$route?.meta?.reducedHeight
    },
  },
  created() {
    window.addEventListener('loginStart', this.loginStart)
    window.addEventListener('beforeunload', this.beforeUnload)
    if (!('serviceWorker' in navigator)) {
      this.serviceWorkerNotSupported = true
    }
  },
  methods: {
    ...mapActions(STOREMODULES.APP, {
      hideOverlay: APP_ACTIONS.HIDE_OVERLAY,
      hideBasket: APP_ACTIONS.HIDE_BASKET,
      setDimensions: APP_ACTIONS.SET_DIMENSION,
    }),
    ...mapMutations(STOREMODULES.APP, {
      setAppPending: APP_MUTATIONS.SET_APP_PENDING,
    }),
    /** TODO: Should be refactored */
    setOverlayInactive() {
      if (this[APP_CONSTANTS.OVERLAY_IS_VISIBLE]) {
        this.hideOverlay()
        this.hideBasket()
      }
    },
    onResize: debounce(function () {
      this.setDimensions({
        [APP_CONSTANTS.WIDTH]: document.documentElement.clientWidth || document.body.clientWidth, // window.innerWidth,
        [APP_CONSTANTS.HEIGHT]: window.innerHeight,
      })
    }, 500),
    beforeUnload() {
      const isMailTo = document.activeElement.protocol === 'mailto:'
      const isTel = document.activeElement.protocol === 'tel:'
      if (isMailTo || isTel) {
        return
      }
      this.setAppPending(true)
    },
    loginStart(e) {
      this.loginStarted = e.detail
    },
  },
}
</script>

<style lang="scss" module>
.base {
  :global(.v-main > .v-main__wrap .container:first-of-type) {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      padding-bottom: 3.75rem;
    }
    padding-top: 0;
    padding-bottom: 0;
  }
}

:global(.launchportal) .base :global(.v-main > .v-main__wrap .container:first-of-type) {
  padding-bottom: 0;
}

.overlay {
  width: 100vw;
  height: calc(100vh - 5rem);
}

.appoverlay.appoverlay {
  top: 0 !important;
  z-index: 10000 !important;
}

.apploader {
  position: relative;

  width: 100vw;
  height: 100vh;
}

.appspinner {
  /*
  <v-progress-circular
    v-if="false"
    :class="$style.appspinner"
    size="128"
    width="2"
    indeterminate
  />
  */
  position: absolute;
  top: 50%;
  left: 50%;

  margin-top: -64px;
  margin-left: -64px;
}

.apptop {
  position: relative;
  z-index: 10000;

  display: flex;
}

@import '~@/styles/always-import.scss';

.base {
  :global(.v-main > .v-main__wrap .container:first-of-type) {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      padding-bottom: 3.75rem;
    }
    padding-top: 0;
    padding-bottom: 0;
  }
}

:global(.launchportal) .base :global(.v-main > .v-main__wrap .container:first-of-type) {
  padding-bottom: 0;
}

.overlay {
  width: 100vw;
  height: calc(100vh - 5rem);
}

.appoverlay.appoverlay {
  top: 0 !important;
  z-index: 10000 !important;
}

.apploader {
  position: relative;

  width: 100vw;
  height: 100vh;
}

.appspinner {
  /*
  <v-progress-circular
    v-if="false"
    :class="$style.appspinner"
    size="128"
    width="2"
    indeterminate
  />
  */
  position: absolute;
  top: 50%;
  left: 50%;

  margin-top: -64px;
  margin-left: -64px;
}

.apptop {
  position: relative;
  z-index: 10000;

  display: flex;
}

:global(.typo3LoginContainer) {
  display: flex;
  flex-flow: wrap;
  margin: 3rem 0 0 0;
  overflow: hidden;

  border-radius: 0.35rem;
  box-shadow: 0em 2em 4rem rgb(0 0 0 / 20%);
}

:global(.imageCol) {
  width: 70%;
}

:global(.buttonCol) {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 30%;
  padding: 1em;

  text-align: center;

  background: rgba(255, 255, 255, 1);
  backdrop-filter: blur(4px) saturate(2);
}

:global(.imageCol img) {
  display: block;
  max-width: 100%;
}

:global {
  @media screen and (max-width: map-get($grid-breakpoints, 'md')) {
    .imageCol,
    .buttonCol {
      width: 100%;
    }
  }

  .btnToKeyCloak:after {
    & :local {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;

      width: 100%;
      height: 100%;

      background: var(--v-primary-base);
      border-radius: 3rem;

      animation: focusTheBtn 5s infinite;

      content: '';
    }
  }
}

@keyframes focusTheBtn {
  0% {
    transform: scale(1);
    opacity: 0.4;
  }

  20%,
  100% {
    transform: scale(1.6, 1.9);
    opacity: 0;
  }
}
</style>
